<template>
  <div class="container-fluid" style="padding-top: 5px">
    <div class="row">
      <!-- List of draggables -->
      <div class="col-12" :class="{ 'col-lg-8': canManageCurrentFederation, 'col-xl-9': canManageCurrentFederation }">
        <div class="container-fluid">
          <!-- Top Info Label -->
          <div class="row">
            <div class="col-12 no-padding-sides">
              <v-alert type="info" style="margin-bottom: 0" dense text>
                Cette base de média sert de bibliothèque. Les draggables peuvent ensuite être utilisés lors de la création et lors de l'édition du plan de travail d'un
                exercice.
              </v-alert>
            </div>
          </div>
          <!-- Draggables -->
          <div class="row">
            <div class="col-12 no-padding-sides">
              <h5
                v-if="
                  (!generales || !generales.length) && (!materiels || !materiels.length) && (!silouhettes || !silouhettes.length) && (!formesGeos || !formesGeos.length)
                "
                class="text-center"
                style="font-style: italic"
              >
                Ajoutez des draggables pour remplir votre bibliothèque.
              </h5>
              <v-expansion-panels focusable multiple v-model="refPanelsOpenedByDefault">
                <!-- General panel -->
                <v-expansion-panel key="panel-generale" v-if="generales && generales.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-draggabletype text-center">Générale</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-draggable">
                      <div class="row justify-content-center row-draggable">
                        <div class="col-12 col-sm-6 col-md-2 col-xl-1" v-for="generale in generales" :key="generale.id">
                          <div class="card shadow-sm card-draggable" :class="generale.isActive ? 'active' : 'not-active'" v-on:click="onCardDraggableClicked(generale)">
                            <img class="card-img-top img-fluid" :src="generale.image" :alt="generale.name" />
                            <!-- <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ generale.name }}</h5>
                            </div> -->
                            <!-- Federation Icons -->
                            <v-btn class="federation-icon xxx-small" dark fab color="indigo accent-2">
                              <v-icon dark>mdi-office-building</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Materiels panel -->
                <v-expansion-panel key="panel-videos" v-if="materiels && materiels.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-draggabletype text-center">Materiel</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-draggable">
                      <div class="row justify-content-center row-draggable">
                        <div class="col-12 col-sm-6 col-md-2 col-xl-1" v-for="materiel in materiels" :key="materiel.id">
                          <div class="card shadow-sm card-draggable" :class="materiel.isActive ? 'active' : 'not-active'" v-on:click="onCardDraggableClicked(materiel)">
                            <img class="card-img-top img-fluid" :src="materiel.image" :alt="materiel.name" />
                            <!-- <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ materiels.alt }}</h5>
                            </div> -->
                            <!-- Federation Icons -->
                            <v-btn class="federation-icon xxx-small" dark fab color="indigo accent-2">
                              <v-icon dark>mdi-office-building</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Silouhettes panel -->
                <v-expansion-panel key="panel-silouhettes" v-if="silouhettes && silouhettes.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-draggabletype text-center">Silouhettes</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-draggable">
                      <div class="row justify-content-center row-draggable">
                        <div class="col-12 col-sm-6 col-md-2 col-xl-1" v-for="silouhette in silouhettes" :key="silouhette.id">
                          <div
                            class="card shadow-sm card-draggable"
                            :class="silouhette.isActive ? 'active' : 'not-active'"
                            v-on:click="onCardDraggableClicked(silouhette)"
                          >
                            <img class="card-img-top img-fluid" :src="silouhette.image" :alt="silouhette.name" />
                            <!-- <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ silouhettes.alt }}</h5>
                            </div> -->
                            <!-- Federation Icons -->
                            <v-btn class="federation-icon xxx-small" dark fab color="indigo accent-2">
                              <v-icon dark>mdi-office-building</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Formes Geos panel -->
                <v-expansion-panel key="panel-formesGeos" v-if="formesGeos && formesGeos.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-draggabletype text-center">Formes Géométriques</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-draggable">
                      <div class="row justify-content-center row-draggable">
                        <div class="col-12 col-sm-6 col-md-2 col-xl-1" v-for="formesGeo in formesGeos" :key="formesGeo.id">
                          <div class="card shadow-sm card-draggable" :class="formesGeo.isActive ? 'active' : 'not-active'" v-on:click="onCardDraggableClicked(formesGeo)">
                            <img class="card-img-top img-fluid" :src="formesGeo.image" :alt="formesGeo.name" />
                            <!-- <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ formesGeos.alt }}</h5>
                            </div> -->
                            <!-- Federation Icons -->
                            <v-btn class="federation-icon xxx-small" dark fab color="indigo accent-2">
                              <v-icon dark>mdi-office-building</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Terrains panel -->
                <v-expansion-panel key="panel-terrains" v-if="fields && fields.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-draggabletype text-center">Terrains</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-draggable">
                      <div class="row justify-content-center row-draggable">
                        <div class="col-12 col-sm-6 col-md-2 col-xl-1" v-for="field in fields" :key="field.id">
                          <div class="card shadow-sm card-draggable" :class="field.isActive ? 'active' : 'not-active'" v-on:click="onCardDraggableClicked(field)">
                            <img class="card-img-top img-fluid" :src="field.image" :alt="field.name" />
                            <!-- <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ formesGeos.alt }}</h5>
                            </div> -->
                            <!-- Federation Icons -->
                            <v-btn class="federation-icon xxx-small" dark fab color="indigo accent-2">
                              <v-icon dark>mdi-office-building</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </div>
      <!-- Manage draggables -->
      <div class="col-12 col-lg-4 col-xl-3" v-if="canManageCurrentFederation">
        <div class="container-fluid sticky-top">
          <!-- Top Info Label -->
          <div class="row">
            <div class="col-12 no-padding-sides">
              <!-- Add draggable -->
              <div class="card" v-if="currentlySelectedDraggables.length === 0">
                <div class="card-body p-auto">
                  <h4 class="card-title text-center my-auto">Importer des draggables</h4>
                </div>
                <div class="card-body p-auto">
                  <!-- Add draggables -->
                  <v-form ref="draggablesCreateForm">
                    <!-- select category -->
                    <v-select
                      :prepend-icon="shapeIcon"
                      outlined
                      label="Catégorie"
                      v-model="addDraggablesFormModel.category"
                      :items="draggableCategoriesFromFederation"
                      item-text="name"
                      item-value="id"
                      :rules="[rules.requireToSelect]"
                      required
                    ></v-select>
                    <!-- upload draggables -->
                    <v-file-input
                      :prepend-icon="icon"
                      v-model="addDraggablesFormModel.images"
                      counter
                      outlined
                      chips
                      show-size
                      accept="image/svg+xml"
                      multiple
                      label="Ajouter des fichiers"
                      :rules="filesInputRules"
                      required
                    ></v-file-input>
                  </v-form>

                  <!-- Add draggables submit button -->
                  <div class="card-body d-flex justify-content-end" style="padding: 1px">
                    <v-btn @click="submitDraggablesCreateForm" :disabled="shouldSubmitDraggablesButtonBeDisabled()">Importer</v-btn>
                  </div>
                </div>
              </div>
              <!-- Edit currently selected draggable -->
              <div class="card" style="max-height: 100%" v-else-if="currentlySelectedDraggables.length === 1">
                <!-- Card illustration -->
                <div style="max-height: 60%; max-width: 500px">
                  <!-- Action buttons -->
                  <div class="draggable-action-buttons-container">
                    <!-- Unselect draggable button -->
                    <v-btn class="draggable-action-button" @click="unselectAllDraggables" fab x-small dark color="grey">
                      <v-icon dark> mdi-close </v-icon>
                    </v-btn>

                    <!-- Edit draggable button -->
                    <v-btn
                      v-if="!isEditingDraggable"
                      class="draggable-action-button"
                      fab
                      dark
                      x-small
                      color="orange"
                      v-on:click="onEditDraggableClicked(currentlySelectedDraggables[0])"
                    >
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>

                    <!-- Delete draggable button -->
                    <v-btn class="draggable-action-button" fab dark x-small color="red" v-on:click="deleteDraggable(currentlySelectedDraggables[0])">
                      <v-icon dark>mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <!-- illustration -->
                  <div class="container-img-svg-edit">
                    <img class="img-svg-edit" :src="currentlySelectedDraggables[0].image" :alt="currentlySelectedDraggables[0].name" />
                  </div>
                </div>
                <!-- title read -->
                <div v-if="!isEditingDraggable" class="card-body p-auto" style="max-height: 40%">
                  <h4 class="card-title text-center my-auto">{{ currentlySelectedDraggables[0].name }}</h4>
                </div>
                <!-- title edit-->
                <div v-else class="card-body p-auto" style="max-height: 40%">
                  <v-form ref="editDraggableForm">
                    <v-text-field :prepend-icon="mdiLabel" v-model="currentlySelectedDraggables[0].name" outlined label="Titre" :rules="titleRules"></v-text-field>
                  </v-form>
                  <!-- Save draggable button -->
                  <v-btn class="mx-2 float-right" color="blue darken-1" text v-on:click="editDraggableTitle(currentlySelectedDraggables[0])"> ENREGISTRER </v-btn>

                  <!-- Cancel editing button -->
                  <v-btn class="mx-2 float-right" color="blue darken-1" text v-on:click="cancelEditDraggableMode()"> ANNULER </v-btn>
                </div>
              </div>
              <!-- List of selected draggables -->
              <div class="card" v-else-if="currentlySelectedDraggables.length > 1">
                <!-- Card illustration -->
                <div style="max-height: 60%; max-width: 500px">
                  <!-- Action buttons -->
                  <div class="draggable-action-buttons-container">
                    <!-- Unselect draggable button -->
                    <v-btn class="draggable-action-button" @click="unselectAllDraggables" fab x-small dark color="grey">
                      <v-icon dark> mdi-close </v-icon>
                    </v-btn>

                    <!-- Delete draggable button -->
                    <v-btn class="draggable-action-button" fab dark x-small color="red" v-on:click="deleteAllSelectedDraggables()">
                      <v-icon dark>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>

                <!-- Body with number of selected draggables and list of selected draggables -->
                <div class="card-body p-auto">
                  <v-list flat>
                    <!-- Number of selected -->
                    <v-subheader> ({{ currentlySelectedDraggables.length }}) draggables sélectionnés </v-subheader>
                    <!-- List of selected -->
                    <v-list-item dense v-for="(currentlySelectedDraggable, i) in currentlySelectedDraggables" :key="i">
                      <v-list-item-icon>
                        <v-icon color="indigo accent-2" dark>mdi-office-building</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="currentlySelectedDraggable.name"> </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllDraggablesCategoriesAndRelatedDraggablesForFederationAsync,
  createDraggableForFederationAsync,
  updateDraggableAsync,
  deleteDraggableAsync,
  getDraggableStringUrl,
} from "@/api/draggablesApi";
import { getIsUserPartOfFederationAsync } from "../../api/federationsApi";
import { VCard, VSelect } from "vuetify/lib";
import store from "@/store";
import PermissionsService from "@/services/PermissionsService";
import { mdiImage, mdiLinkVariant, mdiLabel, mdiShapeOutline } from "@mdi/js";
import _ from "lodash";
import * as DRAGGABLE_CATEGORIES from "@/models/draggableCategories";
import AuthService from "@/services/AuthService";

export default {
  components: {
    VCard,
    VSelect,
  },

  props: {
    federationId_prop: [Number, String],
    moderation: { type: Boolean, default: false },
  },

  data() {
    return {
      authService: AuthService,
      isCurrentUserPartOfFederation: false,
      federationId: null,
      refPanelsOpenedByDefault: [0, 1, 2, 3, 4],
      _draggables: [],
      generales: [],
      materiels: [],
      silouhettes: [],
      formesGeos: [],
      fields: [],
      draggableCategoriesFromFederation: [],
      options: [{ name: "Supprimer cet élément", action: "delete" }],
      currentlySelectedDraggables: [],
      addDraggablesFormModel: {},
      rules: {
        requireToSelect: (v) => !!v || "Veuillez sélectionner une catégorie",
        fileRequired: (v) => !!v || "Veuillez importer un fichier",
      },
      filesInputRules: [(files) => !!files || "Requis.", (files) => !files || !files.some((file) => file.size > 524288000) || "Max 500 Mo"],
      titleRules: [(value) => !!value || "Requis.", (value) => (value && value.length <= 25) || "Max 25 caractères"],
      isEditingDraggable: false,
      draggableTitleBeforeEditing: "",
      icon: mdiImage,
      shapeIcon: mdiShapeOutline,
      linkIcon: mdiLinkVariant,
      mdiLabel: mdiLabel,
    };
  },

  watch: {
    $route() {
      this.initPage();
    },
  },

  computed: {
    canViewCurrentFederation() {
      // Can view own federation and is part of current federation
      let canViewOwnFederationAndIsPartToCurrentFederation = PermissionsService.FederationsPermissionsService.canViewOwnFederation && this.isCurrentUserPartOfFederation;
      // Can view all federations
      let canViewAllFederations = PermissionsService.FederationsPermissionsService.canViewAllFederations;
      return canViewOwnFederationAndIsPartToCurrentFederation || canViewAllFederations;
    },
    canManageCurrentFederation() {
      // Can manage own federation and is part of current federation
      let canManageCurrentFederationAndIsPartToCurrentFederation =
        PermissionsService.FederationsPermissionsService.canManageOwnFederation && this.isCurrentUserPartOfFederation;
      // Can manage all federations
      let canManageAllFederations = PermissionsService.FederationsPermissionsService.canManageAllFederations;
      return canManageCurrentFederationAndIsPartToCurrentFederation || canManageAllFederations;
    },
  },

  async mounted() {
    await this.initPage();
  },

  methods: {
    async initPage() {
      // Override the props values from the url if provided
      this.federationId = this.$route.params.federationId ? parseInt(this.$route.params.federationId) : this.federationId_prop;

      // Check if the current user is part of current federation
      this.isCurrentUserPartOfFederation = await getIsUserPartOfFederationAsync(this.authService.userId, this.federationId);

      // Check if the user can see this page
      if (!this.canViewCurrentFederation) {
        store.dispatch("setSnackbar", {
          title: `Non Autorisé`,
          text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
          status: "warning",
          timeout: 2000,
        });

        this.$router.replace("/");
      }

      // Load and init all draggables
      await this.loadAndInitAllDraggables();
    },

    // Load and init all draggables
    async loadAndInitAllDraggables() {
      // Get all draggables from backend for current user
      await this.loadAllDraggables();
      // Initiate all draggable types
      await this.initAllDraggables();
    },

    // Initiate all draggable types
    async initAllDraggables() {
      // Initiate the generales from draggables
      this.initGenerales();
      // Initiate the materiels from draggables
      this.initMateriels();
      // Initiate the silouhettes from draggables
      this.initSilouhettes();
      // Initiate the formesGeos from draggables
      this.initFormesGeos();
      // Initiate the fields from draggables
      this.initFields();
    },

    // Initiate the generales from draggables
    initGenerales() {
      this.generales = this._draggables.filter((drag) => drag.categoryName == DRAGGABLE_CATEGORIES.GENERALES);
    },

    // Initiate the materiels from draggables
    initMateriels() {
      this.materiels = this._draggables.filter((drag) => drag.categoryName == DRAGGABLE_CATEGORIES.MATERIELS);
    },

    // Initiate the silouhettes from draggables
    initSilouhettes() {
      this.silouhettes = this._draggables.filter((drag) => drag.categoryName == DRAGGABLE_CATEGORIES.SILOUHETTES);
    },

    // Initiate the formesGeos from draggables
    initFormesGeos() {
      this.formesGeos = this._draggables.filter((drag) => drag.categoryName == DRAGGABLE_CATEGORIES.FORMES_GEO);
    },

    // Initiate the fields from draggables
    initFields() {
      this.fields = this._draggables.filter((drag) => drag.categoryName == DRAGGABLE_CATEGORIES.FIELDS);
    },

    // Get all draggables from backend for current user
    async loadAllDraggables() {
      let allDraggablesCategoriesAndRelatedDraggables = await getAllDraggablesCategoriesAndRelatedDraggablesForFederationAsync(this.federationId);

      // Increment the request counter for the loader
      store.dispatch("addRemoveRequest", true);

      let allDraggables = [];

      // For each federation category
      allDraggablesCategoriesAndRelatedDraggables.forEach((draggableCategoryFromFederation) => {        
        // save the categories in a var in order to provide it when creating and when updating draggables
        this.draggableCategoriesFromFederation.push(draggableCategoryFromFederation);

        // For each federation draggable
        draggableCategoryFromFederation.draggables.forEach((draggableFromFederation) => {
          // Set image property to url + path
          draggableFromFederation.image = getDraggableStringUrl(draggableFromFederation.path);
          draggableFromFederation.categoryName = draggableCategoryFromFederation.name;

          allDraggables.push(draggableFromFederation);
        });
      });

      this._draggables = _.cloneDeep(allDraggables);

      // Decrement the request counter for the loader
      store.dispatch("addRemoveRequest", false);
    },

    // Event on Add draggable clicked, submit the form to create a new draggable
    async submitDraggablesCreateForm() {
      var isFormValid = this.$refs.draggablesCreateForm.validate();

      // If valid we can submit it
      if (isFormValid) {
        const formData = new FormData();

        if (!this.addDraggablesFormModel) return;
        if (!this.addDraggablesFormModel.images.length) return;

        formData.append("categoryId", this.addDraggablesFormModel.category);
        formData.append("disc", this.addDraggablesFormModel.discipline);
        //formData.append("fdId", this.federationId);

        this.addDraggablesFormModel.images.forEach((img) => {
          formData.append("formFilesName", img, img.name);
        });

        const urlCreator = window.URL || window.webkitURL;

        const dragList = await createDraggableForFederationAsync(this.federationId, formData);

        // If the creation worked
        if (dragList && dragList.length > 0) {
          // display message to user
          var title = dragList.length > 1 ? "Draggables créés" : "Draggable créé";
          var text = dragList.length > 1 ? "Les draggables ont bien été créés et associés à la fédération." : "Le draggable a bien été créé et associé à la fédération.";

          store.dispatch("setSnackbar", {
            title: title,
            text: text,
            status: "success",
            timeout: 2000,
          });

          // Reset the form
          this.$refs.draggablesCreateForm.reset();

          // Load and init all draggables
          await this.loadAndInitAllDraggables();
        }
      }
      // else display errors
      else {
        // Handle missing category
        if (!this.model.category || this.model.category == -1) {
          store.dispatch("setSnackbar", {
            title: "Catégorie requise",
            text: "Veuillez renseigner la catégorie.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle missing file
        if (!this.model.images || !this.model.images.length) {
          store.dispatch("setSnackbar", {
            title: "Fichier(s) requis",
            text: "Veuillez renseigner le(s) fichier(s).",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    // Delete the selected draggable
    async deleteDraggable(draggable) {
      if (confirm(`Etes-vous sûr de vouloir supprimer ${draggable.name} ?`)) {
        var result = await deleteDraggableAsync(draggable.id);

        if (result > 0) {
          store.dispatch("setSnackbar", {
            title: "Draggable supprimé",
            text: "Le draggable a bien été supprimé.",
            status: "success",
            timeout: 2000,
          });

          // Unselect draggable
          this.unselectAllDraggables();

          // Load and init all draggables
          await this.loadAndInitAllDraggables();
        }
      }
    },

    // Delete all selected draggables
    async deleteAllSelectedDraggables() {
      if (confirm(`Etes-vous sûr de vouloir supprimer les ${this.currentlySelectedDraggables.length} draggables sélectionnés ?`)) {
        let results = true;

        // for each selected draggable
        for (const currentlySelectedDraggable of this.currentlySelectedDraggables) {
          let result = await deleteDraggableAsync(currentlySelectedDraggable.id);

          if (!result > 0) {
            results = results && false;
          }
        }

        if (results) {
          store.dispatch("setSnackbar", {
            title: "Draggables supprimés",
            text: "Les draggables ont bien été supprimés.",
            status: "success",
            timeout: 2000,
          });
        } else {
          store.dispatch("setSnackbar", {
            title: "Attention",
            text: "Un ou plusieurs draggables n'ont pas pu être supprimés.",
            status: "warning",
            timeout: 2000,
          });
        }

        // Unselect draggable
        this.unselectAllDraggables();

        // Load and init all draggables
        await this.loadAndInitAllDraggables();
      }
    },

    // Event on draggable card clicked
    async onCardDraggableClicked(dragParam) {
      let indexDraggable = this._draggables.findIndex((draggable) => draggable.id === dragParam.id);

      if (this._draggables[indexDraggable]) {
        let dragIndexInSelectedList = this.currentlySelectedDraggables.findIndex((selectedDraggable) => selectedDraggable.id === dragParam.id);

        // First we wanna check if the draggable we clicked on is already part of the selected draggables
        let isCurrentDragParamSelected = dragIndexInSelectedList !== -1;

        // If it is already selected, we wanna unselect it
        if (isCurrentDragParamSelected) {
          // cancel edit drag mode
          this.cancelEditDraggableMode();

          // Remove the draggable from the list of selected
          this.currentlySelectedDraggables.splice(dragIndexInSelectedList, 1);
          // Remove the selected class
          this._draggables[indexDraggable].isActive = false;
        }
        // Else it is not already selected, we wanna select it
        else {
          // Add the draggable to the list of selected
          this.currentlySelectedDraggables.push(this._draggables[indexDraggable]);
          // Add the selected class
          this._draggables[indexDraggable].isActive = true;
        }

        // Initiate all draggables
        await this.initAllDraggables();
      }
    },

    // unselect all draggables
    unselectAllDraggables() {
      // if there is only one selected draggable we wanna cancel edit mode
      if (this.currentlySelectedDraggables.length === 1) {
        // cancel edit draggable mode
        this.cancelEditDraggableMode();
      }

      // remove all items from the list of selected
      this.currentlySelectedDraggables = [];

      // remove active class on each
      for (let i = 0; i < this._draggables.length; i++) {
        this._draggables[i].isActive = false;
      }
    },

    // On edit draggable button clicked
    onEditDraggableClicked() {
      this.isEditingDraggable = true;
      this.draggableTitleBeforeEditing = this.currentlySelectedDraggables[0].name;
    },

    // cancel edit draggable mode
    cancelEditDraggableMode(needToRevertDraggableName = true) {
      this.isEditingDraggable = false;
      if (needToRevertDraggableName) {
        this.currentlySelectedDraggables[0].name = this.draggableTitleBeforeEditing.length ? this.draggableTitleBeforeEditing : this.currentlySelectedDraggables[0].name;
      }
      this.draggableTitleBeforeEditing = "";
    },

    // Edit draggable title
    async editDraggableTitle(dragParam) {
      var isFormValid = this.$refs.editDraggableForm.validate();
      // If the form is valid
      if (isFormValid) {
        let indexDraggable = this._draggables.findIndex((drag) => drag.id === dragParam.id);
        let draggableToUpdate = this._draggables[indexDraggable];
        draggableToUpdate.name = dragParam.name;

        var result = await updateDraggableAsync(draggableToUpdate.id, draggableToUpdate);

        if (result && result.id > 0) {
          store.dispatch("setSnackbar", {
            title: `Draggable mis à jour`,
            text: `Le draggable a bien été mis à jour.`,
            status: "success",
            timeout: 2000,
          });

          // Load and init all draggables
          await this.loadAndInitAllDraggables();
          // cancel edit draggable mode
          this.cancelEditDraggableMode(false);
        }
      }
      // else the form is not valid
      else {
        // Handle missing draggable title
        if (!dragParam.name || dragParam.name.length < 1) {
          store.dispatch("setSnackbar", {
            title: "Titre du draggable requis",
            text: "Veuillez renseigner le titre du draggable.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle draggable title too long
        if (dragParam.name && dragParam.name.length > 25) {
          store.dispatch("setSnackbar", {
            title: "Titre du draggable trop long",
            text: "Le titre du draggable ne peut dépasser 25 caractères.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    // Check if the submit new draggables button should be disabled
    shouldSubmitDraggablesButtonBeDisabled() {
      if (
        !this.addDraggablesFormModel ||
        !this.addDraggablesFormModel.images ||
        this.addDraggablesFormModel.images.length === 0 ||
        !this.addDraggablesFormModel.category
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-header {
  padding-top: 0;
  padding-bottom: 0;
}
.card-title-draggabletype {
  font-weight: 800 !important;
}
.container-draggable {
  display: flex;
  padding-top: 1vh;
}
.row-draggable {
  width: 100%;
  height: 100%;
}
.card-draggable {
  display: block;
  height: 100%;
  cursor: pointer;
}
.card-img-top {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 120px;
  width: auto;
  // Specific to draggable
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 2px;
}
.active {
  border: 1px solid #0071c5;
  background-color: #0071c5;
  color: white;
  //   box-shadow: 0 .125rem .25rem rgba(0, 112, 197, 0.412) !important;
}
.sticky-top {
  position: sticky !important;
  top: 0;
  z-index: 2;
}
.draggable-action-buttons-container {
  position: absolute;
  z-index: 2;
  top: 0.5vh;
  right: 0.5vh;
  display: flex;
  flex-direction: column;
}
.draggable-action-button {
  margin-bottom: 0.5vh;
}
.container-img-svg-edit {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-svg-edit {
  max-height: 40vh;
  padding: 5px;
}
.federation-icon {
  position: absolute;
  bottom: 2px;
  left: 2px;
  opacity: 0.7;
}
.xxx-small {
  height: 20px;
  width: 20px;

  .v-icon {
    font-size: 15px;
  }
}
</style>
